var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:_vm.alertClass,attrs:{"data-testid":"ai-chat-view-error-alert","border":"left","type":"info","color":"red","text":""}},[_c('span',{class:[..._vm.textClass]},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }